import clsx from 'clsx';
import type { CallStatus, QcResult } from '@/lib/types';

const CALL_STATUS_TEXT: Record<CallStatus, string> = {
  PENDING: '待处理',
  PROCESSING: '处理中',
  COMPLETED: '已完成',
  FAILED: '失败',
};

const QC_RESULT_TEXT: Record<QcResult, string> = {
  PASS: '合规',
  FAIL: '待整改',
  PENDING: '待复核',
};

export function CallStatusBadge({ status }: { status: CallStatus }) {
  const styles: Record<CallStatus, string> = {
    PENDING: 'bg-amber-50 text-amber-700 ring-amber-200',
    PROCESSING: 'bg-sky-50 text-sky-700 ring-sky-200',
    COMPLETED: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
    FAILED: 'bg-rose-50 text-rose-700 ring-rose-200',
  };
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
        styles[status],
      )}
    >
      {CALL_STATUS_TEXT[status]}
    </span>
  );
}

export function QcResultBadge({ result }: { result: QcResult | null }) {
  if (!result) {
    return (
      <span className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-500 ring-1 ring-inset ring-slate-200">
        未生成
      </span>
    );
  }
  const styles: Record<QcResult, string> = {
    PASS: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
    FAIL: 'bg-rose-50 text-rose-700 ring-rose-200',
    PENDING: 'bg-amber-50 text-amber-700 ring-amber-200',
  };
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
        styles[result],
      )}
    >
      {QC_RESULT_TEXT[result]}
    </span>
  );
}
